export default class LocationItems{
    productName:string;
    sku:string;
    unitName:string;
    clientName :string;
    qty : number;
    storageType:string;
    thumbnail : string;
    expiredDate:string;
    bestBeforeDate : string;
    manufactureDate:string;
    storageTypeName: string;
    serialNoes : string[];
    serialNo:string;
    caseLabelCode :string;
    productId:number;
    productLocationId:number;
}